import axios, { AxiosPromise } from 'axios';

import { IRequestConfig, MethodsTypes } from 'models/Axios';
import IDevolutionTicketForDropdown from 'models/Ticket/Devolution/IDevolutionTicketForDropdown';
import Services from 'services/index.service';

export default class ApiService extends Services<any, any> {

  public async getAllForOrderDropdown(orderId: string) : Promise<AxiosPromise<IDevolutionTicketForDropdown[]>> {
    const config: IRequestConfig<any> = {
      url: `${this.base_url}/ticket/devolution-ticket-order/${orderId}`,
      method: MethodsTypes.get,
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      }
    };

    return await axios(config);
  }

  public async resendDevolutionApprovalMail(ticketId: string) : Promise<AxiosPromise> {
    const config: IRequestConfig<any> = {
      url: `${this.base_url}/ticket/resend-approval-mail/${ticketId}`,
      method: MethodsTypes.post,
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      }
    };

    return await axios(config);
  }
}